import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { mergeMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if(!req.url.includes('oauth2')) {
    return inject(AuthService).getAuthToken().pipe(mergeMap(response => {
      const authReq = req.clone({ setHeaders: { Authorization: `${response.token_type} ${response.access_token}` } });
      return next(authReq);
    }));
  }
  return next(req);
};
